import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../lib/util'


export default function ProtectedRoute() {
    const isAuth = useAuth()

    return isAuth ? <Outlet /> : <Navigate to='login' />
}
